<template>
    <div class="hexan-plus-brom">
        <ul>
            <li>Radikalische Substitution</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'hexan-plus-brom',
};
</script>
